module.exports = __webpack_public_path__ + "static/media/(LH)-05-Capim-Dourado-bijuterias.266bfb86.jpg";